import getUserIdentificationInfo from '../../shared/utils/IdentifyingUser';
import {format} from 'd3-format';

import Thrift from 'thrift';
import CoreApiExceptions from '../../../../../../target/gen-thrift/typescript/core_api_Exceptions_types';
import CoreMathModel from '../../../../../../target/gen-thrift/typescript/core_math_Model_types';
import MoneyModel from '../../../../../../target/gen-thrift/typescript/money_Model_types';
import UnauthenticatedUserSessionExceptions from '../../../../../../target/gen-thrift/typescript/unauthenticated_user_session_Exceptions_types';
import UnauthenticatedUserSessionService from '../../../../../../target/gen-thrift/typescript/UnauthenticatedUserSessionService';
import UnauthenticatedUserSessionModel from '../../../../../../target/gen-thrift/typescript/unauthenticated_user_session_Model_types';
import BarProfitToolService from '../../../../../../target/gen-thrift/typescript/BarProfitToolService';
import BarProfitToolModel from '../../../../../../target/gen-thrift/typescript/bar_profit_tool_Model_types';
import BarProfitToolExceptions from '../../../../../../target/gen-thrift/typescript/bar_profit_tool_Exceptions_types';

export const Validation = {
    validateRequired: function (value) {
        return ((value !== null) && (value !== ''));
    },

    validateEmailAddress: function (value) {
        return /^[\w.+\-]+@[a-zA-Z\d\-]+\.[a-zA-Z\d\-.]+$/.test(value);
    },

    validateZipCode: function (value) {
        return /^\d{5}([\- ]?\d{4})?$/.test(value);
    },

    validateUSPhoneNumber: function (value) {
        return /^\+?1?([()/\.\-\s]*\d){10}\s*((ext|x)\s*\d+)*$/.test(value);
    }
};

export const validateGateFormField = function(field, value) {
    let isValid;
    let errorMessage = "";

    switch (field) {
        case "firstName":
        case "lastName":
            isValid = Validation.validateRequired(value);
            if (!isValid) {
                errorMessage = 'Required field';
            }
            break;
        case "email":
            isValid = Validation.validateRequired(value);
            if (isValid) {
                isValid = Validation.validateEmailAddress(value);
                if (!isValid) {
                    errorMessage = 'Invalid email address';
                }
            } else {
                errorMessage = 'Required field';
            }
            break;
        case "phoneNumber":
            isValid = Validation.validateRequired(value);
            if (isValid) {
                isValid = Validation.validateUSPhoneNumber(value);
                if (!isValid) {
                    errorMessage = 'Invalid US Phone Number';
                }
            } else {
                errorMessage = 'Required field';
            }
            break;
        case "zipCode":
            isValid = Validation.validateRequired(value);
            if (isValid) {
                isValid = Validation.validateZipCode(value);
                if (!isValid) {
                    errorMessage = 'Invalid US ZIP Code';
                }
            } else {
                errorMessage = 'Required field';
            }
            break;
        case "barName":
            isValid = Validation.validateRequired(value);
            if (!isValid) {
                errorMessage = 'Required field';
            }
            break;
        case "barConnection":
            isValid = Validation.validateRequired(value);
            if (!isValid) {
                errorMessage = 'Required field';
            }
            break;
        case "subscribeToBlog":
            isValid = true;
            break;
        default:
            throw "field name not implemented";
    }

    return {
        isValid: isValid,
        errorMessage: errorMessage
    }
};

export const validateBarProfitInputSetInputText = function(setName, inputText) {
    let isValid;
    let errorMessage = "";

    if (setName === "pourCostPercent") {
        isValid = /^[0-9%,.]*$/.test(inputText);
        if (!isValid) {
            errorMessage = 'Invalid percentage string';
        }
    } else if (setName === "averageSittingInventory" || setName === "annualSales") {
        isValid = /^[0-9$,.]*$/.test(inputText);
        if (!isValid) {
            errorMessage = 'Invalid currency string';
        }
    } else {
        throw "validateBarProfitInputSetInputText not implemented for setName " + setName;
    }

    return {
        isValid: isValid,
        errorMessage: errorMessage
    }
};

export const parseBarProfitInputSetInputText = function (setName, inputText) {
    let cleanedInputText = inputText.replace(/[^0-9.]+/g, '');

    if (cleanedInputText === '') {
        cleanedInputText = 0;
    }

    if (setName === "pourCostPercent") {
        return Math.round(parseFloat(cleanedInputText) * 10) / 10;
    } else if (setName === "averageSittingInventory" || setName === "annualSales") {
        return parseInt(Math.round(parseFloat(cleanedInputText)));
    }

    throw "parseBarProfitInputSetInputText not implemented for setName " + setName;
};

export const formatBarProfitInputSetInputValue = function (setName, inputValue) {

    switch(setName) {
        case "pourCostPercent":
            return inputValue === null ? '-' : (inputValue.toFixed(1).replace(/(\d)(?=(\d{3})+(\.|$))/g, '$1,').toString() + '%');
        case "averageSittingInventory":
        case "annualSales":
        case "weeklyUsage":
            return inputValue === null ? '-' : ('$' + inputValue.toFixed(0).replace(/(\d)(?=(\d{3})+(\.|$))/g, '$1,').toString());
        case "inventoryWeeks":
            return inputValue === null ? '-' : (((inputValue < 100) ? inputValue : "100+" ) + " weeks");
        default:
            throw "formatBarProfitInputSetInputValue not implemented for setName " + setName;
    }

};

export const formatBoxPlotBarProfitInputSetInputValue = function (setName, inputValue) {

    switch(setName) {
        case "pourCostPercent":
        case "inventoryWeeks":
            return formatBarProfitInputSetInputValue(setName, inputValue);
        case "averageSittingInventory":
        case "annualSales":
        case "weeklyUsage":
            if (inputValue === null) {
                return '-';
            } else if (Math.abs(inputValue) >= 1e6) {
                return '$' + Number((inputValue/1e6).toPrecision(2)) + 'M';
            } else if (Math.abs(inputValue) >= 1e3) {
                return '$' + Number((inputValue/1e3).toPrecision(2)) + 'k';
            } else {
                return formatBarProfitInputSetInputValue(setName, inputValue);
            }
        default:
            throw "formatBoxPlotBarProfitInputSetInputValue not implemented for setName " + setName;
    }

};

export const takeObjectAndMakeBottomLevelDecimalValuesIntoFloats = function(obj) {
    if (obj !== null && typeof(obj) === 'object' && obj.constructor) {
        var newObj = obj.constructor(obj);

        Object.keys(obj).forEach(function(key) {
            var value = obj[key];
            if (value === null) {
                newObj[key] = value;
            } else if (value instanceof CoreMathModel.Decimal) {
                newObj[key] = value.value / Math.pow(10, value.scale);
            } else if (typeof(value) === 'object') {
                newObj[key] = takeObjectAndMakeBottomLevelDecimalValuesIntoFloats(value);
            } else {
                newObj[key] = value;
            };
        });
        return newObj;
    } else {
        throw 'object expected';
    }
};

var unauthenticatedUserSessionServiceClient = function() {
    var transport = new Thrift.TXHRTransport(
        "/t/UnauthenticatedUserSessionService",
        {useCORS: true}
    );
    var protocol = new Thrift.TJSONProtocol(transport);
    return new UnauthenticatedUserSessionService.UnauthenticatedUserSessionServiceClient(protocol);
}();

var barProfitToolServiceClient = function() {
    var transport = new Thrift.TXHRTransport(
        "/t/BarProfitToolService",
        {useCORS: true}
    );
    var protocol = new Thrift.TJSONProtocol(transport);
    return new BarProfitToolService.BarProfitToolServiceClient(protocol);
}();

export const logException = function(errorId, exception, args) {
    var errorUrl = '/log_js_error/';
    $.post(errorUrl, {
        stack: {
            errorId: errorId,
            args: JSON.stringify(args),
            exception: exception && exception.name || exception,
            url: window.location.href,
            isAdBlockActive: window.isAdBlockActive,
        },
    });
};

export const ensureUnauthenticatedUserSessionIdInCookie = function(callback) {
    var sessionId = Utils.getCookie('unauthenticatedUserSessionId');
    if (!sessionId) {
        var userIdentificationInfo = getUserIdentificationInfo();
        unauthenticatedUserSessionServiceClient.createSession(
            userIdentificationInfo.canvasData,
            userIdentificationInfo.webGLVendor,
            userIdentificationInfo.webGLRenderer,
            userIdentificationInfo.plugins,
            userIdentificationInfo.localStorageAllowed,
            userIdentificationInfo.sessionStorageAllowed,
            userIdentificationInfo.cookieAllowed,
            userIdentificationInfo.platform,
            userIdentificationInfo.doNotTrack,
            userIdentificationInfo.timezone,
            userIdentificationInfo.resolution,
            document.referrer,
            (result) => {
                if (result instanceof Error) {
                    logException('0FB59AD4-03DB-45AD-B034-3E01E3B0A2D9', result, [userIdentificationInfo, document.referrer, callback]);
                    throw result;
                }

                Utils.setCookie('unauthenticatedUserSessionId', result.value);
                callback(result.value);
            }
        );
    } else {
        callback(sessionId);
    }
};

export const deleteAndGetNewUnauthenticatedUserSessionIdCookie = function(callback) {
    Utils.deleteCookie('unauthenticatedUserSessionId');
    var userIdentificationInfo = getUserIdentificationInfo();
    unauthenticatedUserSessionServiceClient.createSession(
        userIdentificationInfo.canvasData,
        userIdentificationInfo.webGLVendor,
        userIdentificationInfo.webGLRenderer,
        userIdentificationInfo.plugins,
        userIdentificationInfo.localStorageAllowed,
        userIdentificationInfo.sessionStorageAllowed,
        userIdentificationInfo.cookieAllowed,
        userIdentificationInfo.platform,
        userIdentificationInfo.doNotTrack,
        userIdentificationInfo.timezone,
        userIdentificationInfo.resolution,
        document.referrer,
        (result) => {
            if (result instanceof Error) {
                logException('36148137-D4D7-44C7-8609-B81BAF5C3340', result, [userIdentificationInfo, document.referrer, callback]);
                throw result;
            }

            Utils.setCookie('unauthenticatedUserSessionId', result.value);
            callback(result.value);
        }
    );
};

export const createFirstQuestionSet = function(sessionId, callback, failCallback) {
    var args = arguments;
    barProfitToolServiceClient.createFirstQuestionSet(
        new UnauthenticatedUserSessionModel.UnauthenticatedUserSessionId({
            value: sessionId
        }),
        (result) => {
            if (result instanceof Error) {
                if (result instanceof UnauthenticatedUserSessionExceptions.UnknownUnauthenticatedUserSessionIdException) {
                    deleteAndGetNewUnauthenticatedUserSessionIdCookie(function(sessionId) {
                        createFirstQuestionSet(sessionId, callback, failCallback);
                    });
                } else {
                    if (failCallback !== undefined) {
                        failCallback(result, args);
                    } else {
                        logException('B01C79DB-6E92-4B42-8D50-12CE4F00540F', result, args);
                        throw result;
                    }
                }
            } else {
                callback(result.value, sessionId);                
            }
        }
    );
}

export const answerFirstQuestionSet = function(initialInputFormId, gateInput, callback) {
    var args = arguments;
    barProfitToolServiceClient.answerFirstQuestionSet(
        new BarProfitToolModel.FirstQuestionSetId({
            value: initialInputFormId
        }),
        gateInput.firstName,
        gateInput.lastName,
        gateInput.zipCode,
        gateInput.phoneNumber,
        gateInput.email,
        gateInput.barName,
        gateInput.barConnection,
        (result) => {
            if (result instanceof Error) {
                logException('0526B75F-C212-4BFA-B067-302E2E898F40', result, args);
                throw result;
            }

            callback();
        }
    );
};

export const createSecondQuestionSet = function(sessionId, callback, failCallback) {
    var args = arguments;
    barProfitToolServiceClient.createSecondQuestionSet(
        new UnauthenticatedUserSessionModel.UnauthenticatedUserSessionId({
            value: sessionId
        }),
        (result) => {
            if (result instanceof Error) {
                if (failCallback !== undefined) {
                    failCallback(result, args);
                } else {
                    logException('95DBBB85-C422-47DD-8432-479AFDFBE3A1', result, args);
                    throw result;
                }
            } else {
                callback(result.value);
            }
        }
    );
};

export const answerSecondQuestionSet = function(presentationId, input, callback) {
    var args = arguments;

    let averageSittingInventoryInCurrency;
    if (input.averageSittingInventory.wine === null) {
        averageSittingInventoryInCurrency = new BarProfitToolModel.ProductCategoryAndOrTotalValue({
            totalValue: input.averageSittingInventory.total
        });
    } else {
        averageSittingInventoryInCurrency = new BarProfitToolModel.ProductCategoryAndOrTotalValue({
            productCategoryValues: new BarProfitToolModel.ProductCategoryValues({
                wine: input.averageSittingInventory.wine,
                beer: input.averageSittingInventory.beer,
                spirit: input.averageSittingInventory.spirits,
            })
        });
    }

    let annualSalesInCurrency;
    if (input.annualSales.wine === null) {
        annualSalesInCurrency = new BarProfitToolModel.ProductCategoryAndOrTotalValue({
            totalValue: input.annualSales.total
        });
    } else {
        annualSalesInCurrency = new BarProfitToolModel.ProductCategoryAndOrTotalValue({
            productCategoryValues: new BarProfitToolModel.ProductCategoryValues({
                wine: input.annualSales.wine,
                beer: input.annualSales.beer,
                spirit: input.annualSales.spirits,
            })
        });
    }

    let pourCostPerMille;
    if (input.pourCostPercent.wine === null) {
        pourCostPerMille = new BarProfitToolModel.ProductCategoryAndOrTotalValue({
            totalValue: input.pourCostPercent.total * 10
        });
    } else {
        pourCostPerMille = new BarProfitToolModel.ProductCategoryAndOrTotalValue({
            totalValue: input.pourCostPercent.total * 10,
            productCategoryValues: new BarProfitToolModel.ProductCategoryValues({
                wine: input.pourCostPercent.wine * 10,
                beer: input.pourCostPercent.beer * 10,
                spirit: input.pourCostPercent.spirits * 10,
            })
        });
    }

    barProfitToolServiceClient.answerSecondQuestionSet(
        new BarProfitToolModel.SecondQuestionSetId({
            value: presentationId
        }),
        new BarProfitToolModel.SecondAnswerSet({
            currency: MoneyModel.Currency.USD,
            averageSittingInventoryInCurrency,
            annualSalesInCurrency,
            pourCostPerMille
        }),
        (result) => {
            if (result instanceof Error) {
                logException('A53277C3-5F6F-44EC-8FBD-DB8232C6CA81', result, args);
                throw result;
            }

            callback(result.value);
        }
    );
};

export const getReport = function(sessionId, submissionId, callback, failCallback) {
    var args = arguments;
    barProfitToolServiceClient.getReport(
        new UnauthenticatedUserSessionModel.UnauthenticatedUserSessionId({
            value: sessionId
        }),
        new BarProfitToolModel.SecondAnswerSetId({
            value: submissionId
        }),
        (result) => {
            if (result instanceof Error) {
                if (exception instanceof UnauthenticatedUserSessionExceptions.UnknownUnauthenticatedUserSessionIdException) {
                    deleteAndGetNewUnauthenticatedUserSessionIdCookie(function(sessionId) {
                        getReport(sessionId, submissionId, callback, failCallback);
                    });
                } else {
                    if (failCallback !== undefined) {
                        failCallback(result, args);
                    } else {
                        logException('0B0AF0C0-4749-493A-988B-1A23381DAD55', result, args);
                        throw result;
                    }
                }
            } else {
                callback(result);                
            }
        }
    );
};

